import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  collaboratorsListRequest: ['projectId'],
  collaboratorsListSuccess: ['listData'],
  collaboratorsListFailure: ['listError'],

  collaboratorsAddRequest: ['params'],
  collaboratorsAddSuccess: ['addData'],
  collaboratorsAddFailure: ['addError'],

  collaboratorsRemoveRequest: ['collaboratorId', 'projectId'],
  collaboratorsRemoveSuccess: ['removeData'],
  collaboratorsRemoveFailure: ['removeError'],
})

export const CollaboratorTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  listData: [],
  listFetching: null,
  listError: null,

  addData: [],
  addFetching: null,
  addError: null,

  removeData: [],
  removeFetching: null,
  removeError: null,
})

/* ------------- Reducers ------------- */

export const listRequest = (state) =>
  state.merge({ listFetching: true, listError: null })

export const listSuccess = (state, { listData }) =>
  state.merge({ listFetching: false, listData })

export const listFailure = (state, { listError }) => {
  return state.merge({ listFetching: false, listError })
}

export const addRequest = (state) =>
  state.merge({ addFetching: true, addError: null })

export const addSuccess = (state, { addData }) =>
  state.merge({ addFetching: false, addData })

export const addFailure = (state, { addError }) => {
  return state.merge({ addFetching: false, addError })
}

export const removeRequest = (state) =>
  state.merge({ removeFetching: true, removeError: null })

export const removeSuccess = (state, { removeData }) =>
  state.merge({ removeFetching: false, removeData })

export const removeFailure = (state, { removeError }) => {
  return state.merge({ removeFetching: false, removeError })
}

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const CollaboratorSelectors = {
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.COLLABORATORS_LIST_REQUEST]: listRequest,
  [Types.COLLABORATORS_LIST_SUCCESS]: listSuccess,
  [Types.COLLABORATORS_LIST_FAILURE]: listFailure,

  [Types.COLLABORATORS_ADD_REQUEST]: addRequest,
  [Types.COLLABORATORS_ADD_SUCCESS]: addSuccess,
  [Types.COLLABORATORS_ADD_FAILURE]: addFailure,

  [Types.COLLABORATORS_REMOVE_REQUEST]: removeRequest,
  [Types.COLLABORATORS_REMOVE_SUCCESS]: removeSuccess,
  [Types.COLLABORATORS_REMOVE_FAILURE]: removeFailure
})



// WEBPACK FOOTER //
// ./src/Redux/CollaboratorRedux.js